import React from 'react';
import {t} from 'i18next';
import {Box, Stack, Typography} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import './CenterHeader.scss';
import ArrButton from '../../../common/arr-button/ArrButton';

export interface CenterHeaderProps {
  uniqueDocIdCount: number;
  canAdd?: boolean;
  canDiscard?: boolean;
  onAdd?: () => void;
  onDiscardChanges?: () => void;
}

const CenterHeader: React.FC<CenterHeaderProps> = ({
  uniqueDocIdCount = 0,
  canAdd = true,
  canDiscard = false,
  onAdd,
  onDiscardChanges,
}) => {
  const handleButtonClick = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    onAdd && onAdd();
  };

  const handleOnButtonKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.key === 'Enter' || e.code === 'Enter') {
      e.stopPropagation();
      onAdd && onAdd();
    }
  };

  const handleDiscardButtonClick = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    onDiscardChanges && onDiscardChanges();
  };

  const handleOnDiscardButtonKeyDown = (
    e: React.KeyboardEvent<HTMLElement>
  ) => {
    if (e.key === 'Enter' || e.code === 'Enter') {
      e.stopPropagation();
      onDiscardChanges && onDiscardChanges();
    }
  };

  return (
    <Stack direction="row" spacing={3} className="session-search-center-header">
      <ArrButton
        startIcon={<AddIcon />}
        size="small"
        onClick={handleButtonClick}
        onKeyDown={handleOnButtonKeyDown}
        className={`button-add ${canAdd ? '' : 'btn-disabled'}`}
        dataTestId="button-add"
        isAriaDisabled={!canAdd}
        tabIndex={0}
      >
        {t('sessionSearch.newSearchButton')}
      </ArrButton>
      <Typography
        className="typo-text body4_size uniqueDocIdCount"
        data-testid={`center-header-unique-doc-id-label`}
        tabIndex={0}
      >
        {t('sessionSearch.uniqueDocIdLabel', {count: uniqueDocIdCount})}
      </Typography>
      {canDiscard && (
        <>
          <Box sx={{flexGrow: 1}} />
          <ArrButton
            size="small"
            variant="secondary"
            onClick={handleDiscardButtonClick}
            onKeyDown={handleOnDiscardButtonKeyDown}
            className="button-discard-changes"
            dataTestId="button-discard-changes"
          >
            {t('sessionSearch.discardChangesButton')}
          </ArrButton>
        </>
      )}
    </Stack>
  );
};
export default CenterHeader;
